import * as React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/styles";
import clsx from "classnames";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";

const useStyles = makeStyles({
    container: {
        position: "absolute",
        top: "4px",
        left: "4px",
        zIndex: 4,
        opacity: 0,
        transition: "all .2s ease-in-out",
        borderRadius: "50%",
        background: "rgba(255, 255, 255, 0.7)",
        height: "32px",
        width: "32px",

        "&.show": {
            opacity: 1,
        },
        "&.list": {
            top: "8px",
            left: "none",
        },
        "& .MuiCheckbox-colorSecondary": {
            color: theme.palette.grey,
        },
        "& .Mui-checked": {
            color: theme.palette.primary1Color,
        },
    },
    checkbox: {
        position: "absolute",
        top: "4px",
        left: "4px",
        padding: 0,
        backgroundColor: "transparent !important", // force disable ripple effect

        "& .MuiSvgIcon-root": {
            fontSize: 24,
        },
    },
});

interface IOwnProps {
    hover: boolean;
    bulkItems: any;
    value: any;
    onChange: (e: any, checked: boolean) => void;
    list: boolean;
}

const BulkSelector = ({ hover, bulkItems, value, onChange, list }: IOwnProps) => {
    const classes = useStyles({});

    const checked = React.useMemo(() => bulkItems.includes(value.id || value._id), [bulkItems, value]);
    const show = hover || checked || bulkItems.allSelected;
    const preventDefault = React.useCallback((e: any) => {
        e.stopPropagation();
    }, []);

    return (
        <div onClick={preventDefault} className={clsx(classes.container, { show, list: !!list })}>
            {show && (
                <Checkbox
                    checked={checked}
                    value={value.id ? value.id : value._id}
                    onChange={onChange}
                    className={classes.checkbox}
                    data-test={DATATEST.GALLERY.ITEM_BULK_SELECT}
                    disableRipple={true}
                />
            )}
        </div>
    );
};

export default BulkSelector;
